<template>
    <div>
        <myHeader class="my-header"></myHeader>


        <div class="demo-collapse">
            <div class="page-title">
                常见问题
            </div>

            <el-collapse v-model="activeNames" @change="handleChange">
    
            </el-collapse>
        </div>

        <myFooter class="footer"></myFooter>
    </div>

</template>

<script>
import myFooter from '../components/myFooter.vue';
import myHeader from '../components/myHeader.vue';

export default {
    data() {
        return {
            activeNames: ''
        }
    },
    components: {
        myFooter,
        myHeader
    },

    methods: {
        handleChange: (val) => {
            console.log(val)
        }
    }
}

</script>

<style lang="less" scoped>
.demo-collapse {
    margin: 90px 0 0px 0;
    padding: 0 20vw;
}

.page-title {
    font-size: 40px;
    font-weight: 700;
    line-height: 100px;
    height: 100px;
}

.footer {
    // position: absolute;
    bottom: 0;
    width: 100%;
    margin-top: 50px;
}


@media (max-width: 768px) {
    .page-title {
        font-size: 18px !important;
    }

    .demo-collapse {
        padding: 2vw !important;
    }

    .footer {
        position: relative !important;
        bottom: 0;
        width: 100%;
    }

}
</style>